const ErrorMessage = ({ message }: { message: string }) => {
  return <p className="font-semibold text-error">{message}</p>;
};

export default ErrorMessage;
